import { wouldEmitUtilityClasses } from '@smoothie-framework/ui-styles/styling';
function pickCanonicalUtilityValue(canonicalName, canonicalValue, aliasName, aliasValue) {
    if (canonicalValue === undefined) {
        return aliasValue;
    }
    if (wouldEmitUtilityClasses(canonicalName, canonicalValue)) {
        return canonicalValue;
    }
    if (aliasValue !== undefined && wouldEmitUtilityClasses(aliasName, aliasValue)) {
        return aliasValue;
    }
    return canonicalValue;
}
export function resolveCanonicalUtilityProps(props) {
    const hover = props._hover;
    const focus = props._focus;
    const active = props._active;
    const display = props.display;
    const hideFrom = props.hideFrom;
    const hideBelow = props.hideBelow;
    const columns = props.columns;
    const rows = props.rows;
    const areas = props.areas;
    const flow = props.flow;
    const autoRows = props.autoRows;
    const autoColumns = props.autoColumns;
    const inline = props.inline;
    const area = props.area;
    const colSpan = props.colSpan;
    const colStart = props.colStart;
    const colEnd = props.colEnd;
    const rowSpan = props.rowSpan;
    const rowStart = props.rowStart;
    const rowEnd = props.rowEnd;
    const gap = props.gap;
    const gapX = props.gapX;
    const gapY = props.gapY;
    const align = props.align;
    const justify = props.justify;
    const alignItems = props.alignItems;
    const alignContent = props.alignContent;
    const alignSelf = props.alignSelf;
    const justifyContent = props.justifyContent;
    const justifyItems = props.justifyItems;
    const justifySelf = props.justifySelf;
    const placeContent = props.placeContent;
    const placeItems = props.placeItems;
    const placeSelf = props.placeSelf;
    const wrap = props.wrap;
    const direction = props.direction;
    const width = pickCanonicalUtilityValue('width', props.width, 'w', props.w);
    const height = pickCanonicalUtilityValue('height', props.height, 'h', props.h);
    const minWidth = pickCanonicalUtilityValue('minWidth', props.minWidth, 'minW', props.minW);
    const maxWidth = pickCanonicalUtilityValue('maxWidth', props.maxWidth, 'maxW', props.maxW);
    const minHeight = pickCanonicalUtilityValue('minHeight', props.minHeight, 'minH', props.minH);
    const maxHeight = pickCanonicalUtilityValue('maxHeight', props.maxHeight, 'maxH', props.maxH);
    const basis = props.basis;
    const boxSizing = props.boxSizing;
    const padding = pickCanonicalUtilityValue('padding', props.padding, 'p', props.p);
    const paddingX = pickCanonicalUtilityValue('paddingX', props.paddingX, 'px', props.px);
    const paddingY = pickCanonicalUtilityValue('paddingY', props.paddingY, 'py', props.py);
    const paddingTop = pickCanonicalUtilityValue('paddingTop', props.paddingTop, 'pt', props.pt);
    const paddingRight = pickCanonicalUtilityValue('paddingRight', props.paddingRight, 'pr', props.pr);
    const paddingBottom = pickCanonicalUtilityValue('paddingBottom', props.paddingBottom, 'pb', props.pb);
    const paddingLeft = pickCanonicalUtilityValue('paddingLeft', props.paddingLeft, 'pl', props.pl);
    const paddingStart = pickCanonicalUtilityValue('paddingStart', props.paddingStart, 'ps', props.ps);
    const paddingEnd = pickCanonicalUtilityValue('paddingEnd', props.paddingEnd, 'pe', props.pe);
    const margin = pickCanonicalUtilityValue('margin', props.margin, 'm', props.m);
    const marginX = pickCanonicalUtilityValue('marginX', props.marginX, 'mx', props.mx);
    const marginY = pickCanonicalUtilityValue('marginY', props.marginY, 'my', props.my);
    const marginTop = pickCanonicalUtilityValue('marginTop', props.marginTop, 'mt', props.mt);
    const marginRight = pickCanonicalUtilityValue('marginRight', props.marginRight, 'mr', props.mr);
    const marginBottom = pickCanonicalUtilityValue('marginBottom', props.marginBottom, 'mb', props.mb);
    const marginLeft = pickCanonicalUtilityValue('marginLeft', props.marginLeft, 'ml', props.ml);
    const marginStart = pickCanonicalUtilityValue('marginStart', props.marginStart, 'ms', props.ms);
    const marginEnd = pickCanonicalUtilityValue('marginEnd', props.marginEnd, 'me', props.me);
    const spaceX = props.spaceX;
    const spaceY = props.spaceY;
    const translateX = props.translateX;
    const translateY = props.translateY;
    const background = pickCanonicalUtilityValue('background', props.background, 'bg', props.bg);
    const backgroundColor = props.backgroundColor;
    const color = props.color;
    const boxShadow = pickCanonicalUtilityValue('boxShadow', props.boxShadow, 'shadow', props.shadow);
    const zIndex = props.zIndex;
    const textStyle = props.textStyle;
    const textAlign = props.textAlign;
    const cursor = props.cursor;
    const border = props.border;
    const borderTop = props.borderTop;
    const borderBottom = props.borderBottom;
    const borderLeft = props.borderLeft;
    const borderRight = props.borderRight;
    const borderStart = props.borderStart;
    const borderEnd = props.borderEnd;
    const borderX = props.borderX;
    const borderY = props.borderY;
    const borderColor = props.borderColor;
    const borderTopColor = props.borderTopColor;
    const borderBottomColor = props.borderBottomColor;
    const borderLeftColor = props.borderLeftColor;
    const borderRightColor = props.borderRightColor;
    const borderStartColor = props.borderStartColor;
    const borderEndColor = props.borderEndColor;
    const borderXColor = props.borderXColor;
    const borderYColor = props.borderYColor;
    const borderStyle = props.borderStyle;
    const borderTopStyle = props.borderTopStyle;
    const borderBottomStyle = props.borderBottomStyle;
    const borderLeftStyle = props.borderLeftStyle;
    const borderRightStyle = props.borderRightStyle;
    const borderStartStyle = props.borderStartStyle;
    const borderEndStyle = props.borderEndStyle;
    const borderWidth = props.borderWidth;
    const borderTopWidth = props.borderTopWidth;
    const borderBottomWidth = props.borderBottomWidth;
    const borderLeftWidth = props.borderLeftWidth;
    const borderRightWidth = props.borderRightWidth;
    const borderStartWidth = props.borderStartWidth;
    const borderEndWidth = props.borderEndWidth;
    const borderXWidth = props.borderXWidth;
    const borderYWidth = props.borderYWidth;
    const divideX = props.divideX;
    const divideY = props.divideY;
    const divideColor = props.divideColor;
    const divideStyle = props.divideStyle;
    const outlineColor = props.outlineColor;
    const borderRadius = pickCanonicalUtilityValue('borderRadius', props.borderRadius, 'rounded', props.rounded);
    const borderTopLeftRadius = pickCanonicalUtilityValue('borderTopLeftRadius', props.borderTopLeftRadius, 'roundedTopLeft', props.roundedTopLeft);
    const borderTopRightRadius = pickCanonicalUtilityValue('borderTopRightRadius', props.borderTopRightRadius, 'roundedTopRight', props.roundedTopRight);
    const borderBottomLeftRadius = pickCanonicalUtilityValue('borderBottomLeftRadius', props.borderBottomLeftRadius, 'roundedBottomLeft', props.roundedBottomLeft);
    const borderBottomRightRadius = pickCanonicalUtilityValue('borderBottomRightRadius', props.borderBottomRightRadius, 'roundedBottomRight', props.roundedBottomRight);
    const borderStartStartRadius = pickCanonicalUtilityValue('borderStartStartRadius', props.borderStartStartRadius, 'roundedStartStart', props.roundedStartStart);
    const borderStartEndRadius = pickCanonicalUtilityValue('borderStartEndRadius', props.borderStartEndRadius, 'roundedStartEnd', props.roundedStartEnd);
    const borderEndStartRadius = pickCanonicalUtilityValue('borderEndStartRadius', props.borderEndStartRadius, 'roundedEndStart', props.roundedEndStart);
    const borderEndEndRadius = pickCanonicalUtilityValue('borderEndEndRadius', props.borderEndEndRadius, 'roundedEndEnd', props.roundedEndEnd);
    const borderInlineStartRadius = pickCanonicalUtilityValue('borderInlineStartRadius', props.borderInlineStartRadius, 'roundedStart', props.roundedStart);
    const borderInlineEndRadius = pickCanonicalUtilityValue('borderInlineEndRadius', props.borderInlineEndRadius, 'roundedEnd', props.roundedEnd);
    const borderTopRadius = pickCanonicalUtilityValue('borderTopRadius', props.borderTopRadius, 'roundedTop', props.roundedTop);
    const borderBottomRadius = pickCanonicalUtilityValue('borderBottomRadius', props.borderBottomRadius, 'roundedBottom', props.roundedBottom);
    const borderLeftRadius = pickCanonicalUtilityValue('borderLeftRadius', props.borderLeftRadius, 'roundedLeft', props.roundedLeft);
    const borderRightRadius = pickCanonicalUtilityValue('borderRightRadius', props.borderRightRadius, 'roundedRight', props.roundedRight);
    const grow = props.grow;
    const shrink = props.shrink;
    return {
        ...(hover !== undefined && { _hover: hover }),
        ...(focus !== undefined && { _focus: focus }),
        ...(active !== undefined && { _active: active }),
        ...(display !== undefined && { display }),
        ...(hideFrom !== undefined && { hideFrom }),
        ...(hideBelow !== undefined && { hideBelow }),
        ...(columns !== undefined && { columns }),
        ...(rows !== undefined && { rows }),
        ...(areas !== undefined && { areas }),
        ...(flow !== undefined && { flow }),
        ...(autoRows !== undefined && { autoRows }),
        ...(autoColumns !== undefined && { autoColumns }),
        ...(inline !== undefined && { inline }),
        ...(area !== undefined && { area }),
        ...(colSpan !== undefined && { colSpan }),
        ...(colStart !== undefined && { colStart }),
        ...(colEnd !== undefined && { colEnd }),
        ...(rowSpan !== undefined && { rowSpan }),
        ...(rowStart !== undefined && { rowStart }),
        ...(rowEnd !== undefined && { rowEnd }),
        ...(gap !== undefined && { gap }),
        ...(gapX !== undefined && { gapX }),
        ...(gapY !== undefined && { gapY }),
        ...(align !== undefined && { align }),
        ...(justify !== undefined && { justify }),
        ...(alignItems !== undefined && { alignItems }),
        ...(alignContent !== undefined && { alignContent }),
        ...(alignSelf !== undefined && { alignSelf }),
        ...(justifyContent !== undefined && { justifyContent }),
        ...(justifyItems !== undefined && { justifyItems }),
        ...(justifySelf !== undefined && { justifySelf }),
        ...(placeContent !== undefined && { placeContent }),
        ...(placeItems !== undefined && { placeItems }),
        ...(placeSelf !== undefined && { placeSelf }),
        ...(wrap !== undefined && { wrap }),
        ...(direction !== undefined && { direction }),
        ...(width !== undefined && { width }),
        ...(height !== undefined && { height }),
        ...(minWidth !== undefined && { minWidth }),
        ...(maxWidth !== undefined && { maxWidth }),
        ...(minHeight !== undefined && { minHeight }),
        ...(maxHeight !== undefined && { maxHeight }),
        ...(basis !== undefined && { basis }),
        ...(boxSizing !== undefined && { boxSizing }),
        ...(padding !== undefined && { padding }),
        ...(paddingX !== undefined && { paddingX }),
        ...(paddingY !== undefined && { paddingY }),
        ...(paddingTop !== undefined && { paddingTop }),
        ...(paddingRight !== undefined && { paddingRight }),
        ...(paddingBottom !== undefined && { paddingBottom }),
        ...(paddingLeft !== undefined && { paddingLeft }),
        ...(paddingStart !== undefined && { paddingStart }),
        ...(paddingEnd !== undefined && { paddingEnd }),
        ...(margin !== undefined && { margin }),
        ...(marginX !== undefined && { marginX }),
        ...(marginY !== undefined && { marginY }),
        ...(marginTop !== undefined && { marginTop }),
        ...(marginRight !== undefined && { marginRight }),
        ...(marginBottom !== undefined && { marginBottom }),
        ...(marginLeft !== undefined && { marginLeft }),
        ...(marginStart !== undefined && { marginStart }),
        ...(marginEnd !== undefined && { marginEnd }),
        ...(spaceX !== undefined && { spaceX }),
        ...(spaceY !== undefined && { spaceY }),
        ...(translateX !== undefined && { translateX }),
        ...(translateY !== undefined && { translateY }),
        ...(background !== undefined && { background }),
        ...(backgroundColor !== undefined && { backgroundColor }),
        ...(color !== undefined && { color }),
        ...(boxShadow !== undefined && { boxShadow }),
        ...(zIndex !== undefined && { zIndex }),
        ...(textStyle !== undefined && { textStyle }),
        ...(textAlign !== undefined && { textAlign }),
        ...(cursor !== undefined && { cursor }),
        ...(border !== undefined && { border }),
        ...(borderTop !== undefined && { borderTop }),
        ...(borderBottom !== undefined && { borderBottom }),
        ...(borderLeft !== undefined && { borderLeft }),
        ...(borderRight !== undefined && { borderRight }),
        ...(borderStart !== undefined && { borderStart }),
        ...(borderEnd !== undefined && { borderEnd }),
        ...(borderX !== undefined && { borderX }),
        ...(borderY !== undefined && { borderY }),
        ...(borderColor !== undefined && { borderColor }),
        ...(borderTopColor !== undefined && { borderTopColor }),
        ...(borderBottomColor !== undefined && { borderBottomColor }),
        ...(borderLeftColor !== undefined && { borderLeftColor }),
        ...(borderRightColor !== undefined && { borderRightColor }),
        ...(borderStartColor !== undefined && { borderStartColor }),
        ...(borderEndColor !== undefined && { borderEndColor }),
        ...(borderXColor !== undefined && { borderXColor }),
        ...(borderYColor !== undefined && { borderYColor }),
        ...(borderStyle !== undefined && { borderStyle }),
        ...(borderTopStyle !== undefined && { borderTopStyle }),
        ...(borderBottomStyle !== undefined && { borderBottomStyle }),
        ...(borderLeftStyle !== undefined && { borderLeftStyle }),
        ...(borderRightStyle !== undefined && { borderRightStyle }),
        ...(borderStartStyle !== undefined && { borderStartStyle }),
        ...(borderEndStyle !== undefined && { borderEndStyle }),
        ...(borderWidth !== undefined && { borderWidth }),
        ...(borderTopWidth !== undefined && { borderTopWidth }),
        ...(borderBottomWidth !== undefined && { borderBottomWidth }),
        ...(borderLeftWidth !== undefined && { borderLeftWidth }),
        ...(borderRightWidth !== undefined && { borderRightWidth }),
        ...(borderStartWidth !== undefined && { borderStartWidth }),
        ...(borderEndWidth !== undefined && { borderEndWidth }),
        ...(borderXWidth !== undefined && { borderXWidth }),
        ...(borderYWidth !== undefined && { borderYWidth }),
        ...(divideX !== undefined && { divideX }),
        ...(divideY !== undefined && { divideY }),
        ...(divideColor !== undefined && { divideColor }),
        ...(divideStyle !== undefined && { divideStyle }),
        ...(outlineColor !== undefined && { outlineColor }),
        ...(borderRadius !== undefined && { borderRadius }),
        ...(borderTopLeftRadius !== undefined && { borderTopLeftRadius }),
        ...(borderTopRightRadius !== undefined && { borderTopRightRadius }),
        ...(borderBottomLeftRadius !== undefined && { borderBottomLeftRadius }),
        ...(borderBottomRightRadius !== undefined && { borderBottomRightRadius }),
        ...(borderStartStartRadius !== undefined && { borderStartStartRadius }),
        ...(borderStartEndRadius !== undefined && { borderStartEndRadius }),
        ...(borderEndStartRadius !== undefined && { borderEndStartRadius }),
        ...(borderEndEndRadius !== undefined && { borderEndEndRadius }),
        ...(borderInlineStartRadius !== undefined && { borderInlineStartRadius }),
        ...(borderInlineEndRadius !== undefined && { borderInlineEndRadius }),
        ...(borderTopRadius !== undefined && { borderTopRadius }),
        ...(borderBottomRadius !== undefined && { borderBottomRadius }),
        ...(borderLeftRadius !== undefined && { borderLeftRadius }),
        ...(borderRightRadius !== undefined && { borderRightRadius }),
        ...(grow !== undefined && { grow }),
        ...(shrink !== undefined && { shrink }),
    };
}
//# sourceMappingURL=resolve.js.map